import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Legal disclaimer checkbox for raffle creation.
 * The organizer MUST accept responsibility before creating a campaign.
 */
export default function LegalDisclaimer({ accepted, onAccept }) {
  return (
    <div style={{
      background: 'rgba(255, 193, 7, 0.06)',
      border: '1.5px solid rgba(255, 193, 7, 0.35)',
      borderRadius: 'var(--radius-md, 12px)',
      padding: '1.25rem 1.5rem',
      marginBottom: '1.2rem',
      fontSize: '0.88rem',
      lineHeight: 1.7,
      color: 'var(--dark, #333)',
    }}>
      <div style={{
        fontWeight: 700,
        fontSize: '0.95rem',
        marginBottom: '0.6rem',
        color: '#b8860b',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      }}>
        <span role="img" aria-label="aviso">⚖️</span>
        Declaração de Responsabilidade
      </div>

      <p style={{ margin: '0 0 0.75rem' }}>
        A RifaMaker é uma <strong>plataforma tecnológica</strong> que possibilita a criação de ações entre
        amigos e campanhas beneficentes. Ao criar uma campanha, você declara que:
      </p>

      <ul style={{
        margin: '0 0 0.75rem',
        paddingLeft: '1.25rem',
        listStyle: 'disc',
      }}>
        <li style={{ marginBottom: '0.35rem' }}>
          Sua campanha tem caráter de <strong>ação entre amigos</strong>, fins beneficentes ou sociais.
        </li>
        <li style={{ marginBottom: '0.35rem' }}>
          Você é o <strong>único responsável</strong> por verificar a conformidade da campanha com as leis
          de sua jurisdição.
        </li>
        <li style={{ marginBottom: '0.35rem' }}>
          Você é responsável por obter quaisquer <strong>autorizações legais</strong> necessárias (SPA, SUSEP
          ou outros órgãos competentes).
        </li>
        <li style={{ marginBottom: '0.35rem' }}>
          Você assumirá integralmente a <strong>responsabilidade civil e criminal</strong> decorrente de
          sua campanha.
        </li>
        <li style={{ marginBottom: '0.35rem' }}>
          Você se compromete a <strong>entregar o prêmio</strong> ao contemplado e a honrar todos os
          compromissos da campanha.
        </li>
      </ul>

      <label style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.6rem',
        cursor: 'pointer',
        padding: '0.6rem 0.75rem',
        background: accepted ? 'rgba(0, 206, 158, 0.08)' : 'rgba(0,0,0,0.02)',
        borderRadius: '8px',
        border: accepted ? '1.5px solid rgba(0, 206, 158, 0.4)' : '1.5px solid rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease',
      }}>
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => onAccept(e.target.checked)}
          style={{
            marginTop: '0.2rem',
            width: '18px',
            height: '18px',
            accentColor: 'var(--primary, #00CEB6)',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        />
        <span>
          Li e concordo com os{' '}
          <Link to="/terms" target="_blank" style={{ color: 'var(--primary, #00CEB6)', fontWeight: 600 }}>
            Termos de Uso
          </Link>{' '}
          e a{' '}
          <Link to="/privacy" target="_blank" style={{ color: 'var(--primary, #00CEB6)', fontWeight: 600 }}>
            Política de Privacidade
          </Link>.{' '}
          Declaro que sou o <strong>único responsável</strong> pela legalidade e legitimidade desta campanha
          e que a RifaMaker atua exclusivamente como ferramenta tecnológica.
        </span>
      </label>
    </div>
  );
}
